/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Protocol_Intermediate_Hypertrophy_NameInputs */

const en_us2_protocol_intermediate_hypertrophy_name = /** @type {(inputs: Protocol_Intermediate_Hypertrophy_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intermediate hypertrophy`)
};

const pt_br2_protocol_intermediate_hypertrophy_name = /** @type {(inputs: Protocol_Intermediate_Hypertrophy_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hipertrofia intermediária`)
};

const es_419_protocol_intermediate_hypertrophy_name = /** @type {(inputs: Protocol_Intermediate_Hypertrophy_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hipertrofia intermedia`)
};

const pt_pt2_protocol_intermediate_hypertrophy_name = /** @type {(inputs: Protocol_Intermediate_Hypertrophy_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hipertrofia intermédia`)
};

const fr_fr2_protocol_intermediate_hypertrophy_name = /** @type {(inputs: Protocol_Intermediate_Hypertrophy_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hypertrophie intermédiaire`)
};

const de_de2_protocol_intermediate_hypertrophy_name = /** @type {(inputs: Protocol_Intermediate_Hypertrophy_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fortgeschritten · Hypertrophie`)
};

const it_it2_protocol_intermediate_hypertrophy_name = /** @type {(inputs: Protocol_Intermediate_Hypertrophy_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intermedio · ipertrofia`)
};

/**
* | output |
* | --- |
* | "Intermediate hypertrophy" |
*
* @param {Protocol_Intermediate_Hypertrophy_NameInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const protocol_intermediate_hypertrophy_name = /** @type {((inputs?: Protocol_Intermediate_Hypertrophy_NameInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Protocol_Intermediate_Hypertrophy_NameInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_protocol_intermediate_hypertrophy_name(inputs)
	if (locale === "es-419") return es_419_protocol_intermediate_hypertrophy_name(inputs)
	if (locale === "pt-PT") return pt_pt2_protocol_intermediate_hypertrophy_name(inputs)
	if (locale === "fr-FR") return fr_fr2_protocol_intermediate_hypertrophy_name(inputs)
	if (locale === "de-DE") return de_de2_protocol_intermediate_hypertrophy_name(inputs)
	if (locale === "it-IT") return it_it2_protocol_intermediate_hypertrophy_name(inputs)
	return en_us2_protocol_intermediate_hypertrophy_name(inputs)
});
export { protocol_intermediate_hypertrophy_name as "protocol.intermediate-hypertrophy.name" }